<div class="col-lg-6 question-label">
    <label>{{label ?? question.questionLabel}}
        <span *ngIf="question?.required">*</span>
    </label>
</div>
<div class="col-lg-6">
    <p-inputNumber         
        [class.validate_error_cls]="isFormSubmitted &&meAsControl.invalid"
        [placeholder]="waterMark"  [ngModel]="value"
        [useGrouping]="false" [maxlength]="maxlength" [required]="question.required"
        [name]="question?.name" (onInput) = "onInputChanged($event)"
        #numericboxCtrl>
    </p-inputNumber>
    <span style="color: red" *ngIf="isFormSubmitted && meAsControl.invalid">
             {{validationMessage ?? (meAsControl.errors | json )}}
    </span>
</div>